/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlBranch = "/master/branches";
const urlBranchDeleteMultiple = "/master/branches/delete-multiple";

const state = {
  branches: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * Get list branches
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListBranches({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlBranch}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_BRANCHES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Create branch
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlBranch, payload);
  },

  /**
   * Update branch
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlBranch}/${id}`, payload);
  },

  /**
   * Delete branch
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlBranch}/${id}`);
  },

  /**
   * delete multiple branch
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlBranchDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_BRANCHES(state, data) {
    state.branches = data.items;
    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
